
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Table } from "@common/src/utils/decorator";
import { InjectFunction } from "@common/src/utils/decorator";
import t from "@common/src/i18n/t";
import InventoryCheckPrint from "./components/inventory-check-print.vue";
import dayjs from "dayjs";

const base = namespace("base");
const staff = namespace("staff");
const inventory = namespace("inventory");
const common_warehouse = namespace("common_warehouse");
const app = namespace("app");
const user = namespace("user");
@InjectFunction("dayjs", "emptyToLine", "splitThousands", "permit", "permitApp", "appCode", "addCurrencySymbol")
@Component({ components: { InventoryCheckPrint } })
@Table("loadListData")
export default class ServiceList extends Vue {
  @base.Action getDictionaryList;
  @staff.Action getStaffList;
  @inventory.Action queryInventoryCheckList;
  @inventory.Action saveAllStocktaking;
  @inventory.Action deleteInventoryCheck;
  @inventory.Action saveAddPartialStocktakingParts;
  @common_warehouse.Action queryWarehouseShelfTree;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @user.State userData;
  inventoryCheckList: any[] = [];
  searchForm = {
    stocktakingCode: "",
    warehouseCode: "",
    stocktakingStatus: "",
    stocktakingDateStart: "",
    stocktakingDateEnd: "",
    stocktakingFinishDateStart: "",
    stocktakingFinishDateEnd: "",
    createDateStart: "",
    createDateEnd: ""
  };
  staffList: any = [];
  stocktakingTypeList: any = [];
  created() {
    this.init();
    this.loadListData();
  }
  inventoryCheckStatusList: any = [];
  advisorList: any = [];
  init() {
    this.getDictionaryList("stocktaking_status").then(data => {
      this.inventoryCheckStatusList = data;
    });
    this.getDictionaryList("stocktaking_type").then(data => {
      this.stocktakingTypeList = data;
    });
    if (this.appCode === "speedbiz") {
      this.getStaffList({
        pageSize: 999,
        pageNum: 1
      }).then(data => {
        const staffList = this.$safeValue(data, "data.list", []).map(item => ({
          label: item.staffName,
          value: item.userCode
        }));
        this.staffList = staffList;
      });
    }
    this.queryWarehouseShelfTree({
      pageNum: 1,
      pageSize: 100
    }).then(data => {
      let list = this.$safeValue(data, "data.warehouseList", []);
      let warehouseList = [];
      list.forEach(item => {
        warehouseList.push({
          label: item.warehouseName,
          value: item.warehouseCode
        });
      });
      this.warehouseList = warehouseList;
    });
    this.getStaffList({
      pageNum: 1,
      pageSize: 999
    }).then(data => {
      this.advisorList = data.data.list;
      this.createData.stocktakingUser = this.userData.userCode;
    });
    this.createData.stocktakingDate = dayjs().format("YYYYMMDD");
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.queryInventoryCheckList({
      ...this.searchForm,
      orderItems: this.mix_sortParams,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize
    }).then(data => {
      this.inventoryCheckList = data.data?.list;
      return data;
    });
  }
  get searchList() {
    return [
      {
        label: t("v216_6.inventory-number"),
        type: "input",
        value: "",
        prop: "stocktakingCode"
      },
      {
        label: t("warehouse.warehouse"),
        type: "select",
        value: "",
        selectList: this.warehouseList,
        prop: "warehouseCode"
      },
      {
        label: t("v216_6.inventory-check-type"),
        type: "select",
        value: "",
        selectList: this.stocktakingTypeList,
        prop: "stocktakingType"
      },
      {
        label: t("v216_6.inventory-status"),
        type: "select",
        selectList: this.inventoryCheckStatusList,
        value: "",
        prop: "stocktakingStatus"
      },
      {
        label: t("v216_6.inventory-date"),
        type: "daterange",
        value: "",
        prop: "stocktakingDate",
        valueDistribute: ["stocktakingDateStart", "stocktakingDateEnd"]
      },
      {
        label: t("v213.Created-time"),
        type: "daterange",
        value: "",
        prop: "startOutboundDate",
        valueDistribute: ["createDateStart", "createDateEnd"]
      },
      {
        label: t("other.complete-time"),
        type: "daterange",
        value: "",
        prop: "stocktakingFinishDate",
        valueDistribute: ["stocktakingFinishDateStart", "stocktakingFinishDateEnd"]
      }
    ];
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        this.searchForm[item.prop] = item.value;
      }
    });
    this.loadListData();
  }
  handleView(row) {
    let { href } = this.$router.resolve({
      path: `/inventory/inventory-check/view/${row.stocktakingCode}`
    });
    window.open(href, "_blank");
  }

  activeRow: any = {};
  warehouseList: any = [];
  showPrint = false;
  handleContinueCheck(row) {
    window.open(this.$router.resolve(`/inventory/inventory-check/edit/${row.stocktakingCode}`).href);
  }
  handlePrint(row) {
    this.activeRow = row;
    this.showPrint = true;
  }
  handleDelete(row) {
    this.$confirm(t("v216_6.delete-current-inventory-sheet"), t("v210831.tips"), {
      confirmButtonText: t("v210831.determine"),
      cancelButtonText: t("base.cancel"),
      type: "warning"
    }).then(() => {
      this.deleteInventoryCheck({
        stocktakingCode: row.stocktakingCode
      }).then(() => {
        this.$message.success(t("v210831.delete-succeeded"));
        this.loadListData();
      });
    });
  }
  diffAddSymbol(num) {
    num = Number(num);
    return num > 0 ? "+" + num : num;
  }
  createType = "";
  handleLinkCommand(type) {
    this.createType = type;
    this.showselectWarehouse = true;
  }
  showselectWarehouse = false;
  createData: any = {
    warehouseCode: "",
    stocktakingUser: "",
    stocktakingDate: "",
    stocktakingStatus: "1"
  };
  createDataRules: any = {
    warehouseCode: [{ required: true, message: t("v216_6.please-select-the-inventory-warehouse"), trigger: "change" }],
    stocktakingUser: [{ required: true, message: t("v216_6.please-select-the-inventory-taker"), trigger: "change" }],
    stocktakingDate: [{ required: true, message: t("v216_6.please-select-the-inventory-date"), trigger: "change" }]
  };
  handleSave() {
    (this.$refs["createFormRef"] as any).validate(async valid => {
      if (valid) {
        this.btnStartLoading();
        if (this.createType === "all") {
          this.saveAllStocktaking(this.createData)
            .then(data => {
              this.$router.push(`/inventory/inventory-check/edit/${data.data}`);
            })
            .finally(() => {
              this.btnStopLoading();
            });
        } else {
          this.saveAddPartialStocktakingParts(this.createData)
            .then(data => {
              this.$router.push(`/inventory/inventory-check/edit/${data.data}`);
            })
            .finally(() => {
              this.btnStopLoading();
            });
        }
      }
    });
    // this.createData.stocktakingUser = this.userData.userCode;
    // this.createData.stocktakingDate = dayjs().format("YYYYMMDD");
  }
  stocktakingDateOption: any = {
    disabledDate(row) {
      return dayjs(row).isAfter(dayjs().endOf("d"));
    }
  };
}
